module.exports = __webpack_public_path__ + "img/pic_4.a403750f.jpg";